





































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Breadcrumb from '@/_shared/components/layout/breadcrumb.component.vue';
import BreadcrumbInterface from '@/_shared/components/layout/breadcrumb.interface';
import NewsService from '@/_shared/services/news.service';
import ArticleMiniature from '@/learn/components/article-miniature.component.vue';
import Rep from '@/_shared/entities/rep/rep.entity';
import Article from '@/learn/entities/article.entity';
import CountriesInterface from '@/_shared/interfaces/countries.interface';

@Component({
  components: {
    Breadcrumb,
    ArticleMiniature,
  },
})
export default class NewsArticle extends Vue {
  private hasFinishedLoading = false;
  breadcrumb: BreadcrumbInterface[] = [];
  relatedArticles: Article[] = [];
  article: Article | null = null;
  recommendedStories: Article[] = [];
  private THUMBNAIL_BREAKPOINT = 400
  isMobile = window.screen.width <= this.THUMBNAIL_BREAKPOINT;
  get rep(): Rep { return this.$store.state.RepStore.rep; }
  countryCode = '';

  @Watch('$route.params.id')
  async onIdChanged(): Promise<void> {
    this.setUpLoading();
    await this.initData();
    this.scrollToTop();
    this.finishLoading();
  }

  async scrollToTop() {
    const pageTop = document.querySelector('.article');
    return pageTop?.scrollIntoView();
  }

  async initData(): Promise<void> {
    const articleId = this.$route.params.id;
    await NewsService.getArticleById(articleId)
      .then((article) => {
        this.article = article;
      });
  }

  async created(): Promise<void> {
    window.addEventListener('resize', this.onResize, { passive: true });
    this.setUpLoading();
    this.setStylesheet();
    await this.getCountryCode();
    NewsService.setCountryCode(this.countryCode ?? '');
    NewsService.setLocale(this.rep.localeIso ?? '');
    await this.initData();
    this.finishLoading();
  }

  get postedDate(): string {
    if (!this.article) return '';
    return this.article.getPostedDate();
  }

  setUpLoading(): void {
    this.$store.dispatch('showLoading');
    this.hasFinishedLoading = false;
  }

  finishLoading(): void {
    this.$store.dispatch('hideLoading');
    this.hasFinishedLoading = true;
  }

  onResize() {
    this.isMobile = window.screen.width <= this.THUMBNAIL_BREAKPOINT;
  }

  setStylesheet() {
    const STYLESHEET_ID = 'news-article-stylesheet';
    const isStylesheetAppended = !!document.getElementById(STYLESHEET_ID);
    if (!isStylesheetAppended) {
      this.appendStylesheet(STYLESHEET_ID);
    }
  }

  private appendStylesheet(stylesheetId: string) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = stylesheetId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `${process.env.VUE_APP_NEWS_WP_URI}us/wp-includes/css/dist/block-library/style.min.css`;
    head.appendChild(link);
  }

  private async getCountryCode() {
    const countries = this.$store.state.CountriesStore.countriesList;
    const name = this.rep.shipping.country;
    const countryFound = countries.find((country: CountriesInterface) => country.name === name);
    this.countryCode = countryFound.code || '';
  }
}
